<template>
  <div>
    <VueAliplayer
      :preload="true"
      :autoplay="true"
      :playsinline="false"
      :source="sourceUrl"
      ref="video"
      class="video"
      @canplaythrough="canplaythroughimp"
      @play="onStartPlay"
      :skinLayout="skinLayout"
      :height="videoHeight"
      :video-height="videoHeight"
      style="width: 100%"
    />
    <slot></slot>
  </div>
</template>

<script>
import VueAliplayer from '@/views/test/VueAliplayer.vue'
import util from '@/util/util'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Player',
  components: {
    VueAliplayer
  },
  data() {
    return {
      sourceUrl: '',
      identifier: new Date().getTime(),
      progressToSeek: 0,
      skinLayout: [
        {
          name: 'bigPlayButton',
          align: 'cc'
        },
        {
          name: 'H5Loading',
          align: 'cc'
        },
        {
          name: 'errorDisplay',
          align: 'tlabs',
          x: 0,
          y: 0
        },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            {
              name: 'progress',
              align: 'blabs',
              x: 0,
              y: 44
            },
            {
              name: 'playButton',
              align: 'tl',
              x: 15,
              y: 12
            },
            {
              name: 'timeDisplay',
              align: 'tl',
              x: 10,
              y: 7
            },
            {
              name: 'fullScreenButton',
              align: 'tr',
              x: 10,
              y: 12
            }
          ]
        }
      ],
      videoHeight: util.getVideoHeight() + 'px'
    }
  },
  computed: {
    ...mapState('video', ['resp', 'playInfo', 'currentVideo'])
  },
  watch: {
    playInfo(value, old) {
      console.log('playinfo->----', value, old)
      console.log(value.detail.playURL)

      this.progressToSeek = value.detail.progress ? value.detail.progress : 0

      this.sourceUrl = value.detail.playURL
      this.$refs.video.reloadPlayer()
    },
    currentVideo() {
      this.identifier = new Date().getTime()
    }
  },
  methods: {
    ...mapActions('video', ['requestUploadProgress']),
    uploadProgress() {
      let currentTime = this.$refs.video.getCurrentTime().toFixed(0)
      if (currentTime === 0) return 0
      let params = {
        identifier: this.identifier,
        videoIdentity: this.currentVideo,
        progress: currentTime
      }
      console.log(params)
      this.requestUploadProgress(params)
    },
    getInternalVideoInstance() {
      return this.$refs.video
    },
    canplaythroughimp() {
      let _this = this
      // setTimeout(() => {
      //
      // }, 800)
      if (
        _this.progressToSeek !== 0 &&
        this.playInfo.detail.duration - _this.progressToSeek > 3
      ) {
        console.log('seek' + _this.progressToSeek)
        _this.$refs.video.seek(_this.progressToSeek)

        setTimeout(() => {
          if (_this.$refs.video.getCurrentTime() < _this.progressToSeek) {
            this.canplaythroughimp()
          } else {
            _this.progressToSeek = 0
          }
        }, 500)
      }
    },
    onStartPlay() {
      this.$emit('onStartPlay')
    }
  },

  mounted() {
    setInterval(() => {
      this.uploadProgress()
    }, 10000)
  }
}
</script>

<style lang="scss" scoped>
//.video ::v-deep{
//
//  .prism-fullscreen{
//    height: 500px !important;
//  }
//}
</style>
